import React from 'react'

function About() {
  return (
    <div className='p-10 md:p-20'>
      <h2 className='font-bold mb-4 text-xl'>Our Goals</h2>
      <p className=' mb-8'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Temporibus odio ducimus fugiat sit rerum ad, ut praesentium sunt. 
        Quia voluptates ipsam eveniet saepe quibusdam illo nemo enim deleniti neque maxime.</p>

        <h3 className='font-bold mb-4 text-lg'>Our Vision Statement</h3>
        <p className=' mb-8'>Lorem ipsum dolor,Ipsa sed molestias dolor unde. Odit numquam amet molestiae! 
          Quaerat natus magna repellat debitis! Excepturi quisquam a fuga.</p>

        <h3 className='font-bold mb-4 text-lg'>Our Mission Statement</h3>
        <p className=' mb-8'>Lorem ipsum dolor,Ipsa sed molestias dolor unde. Odit numquam amet molestiae! 
          Quaerat natus magna repellat debitis! Excepturi quisquam a fuga.</p>
    </div>
  )
}

export default About